import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "emailjs-com";
import "./Freetrail.css";
const Freetrailfront = (props) => {
  const [buttond, setButtond] = useState(false);
  const [token, setToken] = useState("");
  const [success, setSuccess] = useState(false);

  {
    /*useEffect(() => {
    if (window.location.search.includes("success=true")) {
      setSuccess(true);
    }
  }, []);*/
  }

  const onCaptcha = (ctoken) => {
    if (ctoken) {
      setToken(ctoken);
      setButtond(true);
    }
  };
  {
    /* email js */
  }
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_oaix81l",
        "template_ue0mzvi",
        e.target,
        "user_hD4EoOQHDr3RkBowxMKdS"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
    setSuccess(true);
  };
  return (
    <div className=" freetrail-bg">
      <div className="trail-content">
        <div>
          <h3>Book Your Free IDE-Cloud Demo Now</h3>
        </div>
        <div>
          <p>
            <i class="fas fa-check-circle"></i>
            30 minutes demo tailored to your needs by a BizTalk and Integration
            expert
          </p>
          <p>
            <i class="fas fa-check-circle"></i>
            One Platform for Microsoft BizTalk Server Operations, Monitoring and
            Analytics
          </p>
          <p>
            <i class="fas fa-check-circle"></i>
            Improve security and administration efficiency of Microsoft BizTalk
            Server
          </p>
        </div>
      </div>
      <div className="trail-form">
        {/* <--netlify -->
        <form
          name="contact"
          method="POST"
          action={"/" + props.redir + "/?success=true"}
          data-netlify="true"
          className="box"
        >
          <input type="hidden" name="form-name" value="contact" />
          <div>
            {success && (
              <p style={{ color: "green" }}>Thanks for your message! </p>
            )}
          </div>
          <div className="sub-input"></div>
          <input type="text" placeholder="First Name" name="name" required />
          <input type="email" placeholder="Email" name="email" required />

          <input type="number" placeholder="Phone Number" name="message" />
          **<ReCAPTCHA
            sitekey="6LeOSF0aAAAAAHntpKB15A5Mdb1TkdKsLwcrXccg"
            onChange={(token) => onCaptcha(token)}
            onExpired={(e) => setToken("")}
            className="captcha"
          />**
          <button
            className="btn btn-primary "
            type="submit"
            disabled={!buttond}
          >
            {props.value}
          </button>
        </form>*/}
        <form onSubmit={sendEmail} className="box">
          <div>
            {success && (
              <p style={{ color: "green" }}>Thanks for your message! </p>
            )}
          </div>
          <div className="sub-input"></div>
          <input
            type="text"
            placeholder="First Name"
            name="user_name"
            required
          />
          <input type="email" placeholder="Email" name="user_email" required />

          <input type="number" placeholder="Phone Number" name="message" />
          <button
            className="btn btn-primary "
            type="submit"
            disabled={!buttond}
          >
            {props.value}
          </button>
        </form>
        <ReCAPTCHA
          sitekey="6LeOSF0aAAAAAHntpKB15A5Mdb1TkdKsLwcrXccg"
          onChange={(token) => onCaptcha(token)}
          onExpired={(e) => setToken("")}
          className="captcha"
        />
      </div>
    </div>
  );
};

export default Freetrailfront;
